document.addEventListener("DOMContentLoaded", function () {
  const url = new URL(window.location.href);
  const viewParam = url.searchParams.get("view");

  function showAll(selector) {
    document.querySelectorAll(selector).forEach(el => {
      el.style.display = "";
    });
  }

  function hideAll(selector) {
    document.querySelectorAll(selector).forEach(el => {
      el.style.display = "none";
    });
  }

  if (viewParam === "wholesale") {
    hideAll('.wholesale-login-subtle');
    showAll('.wholesale-apply');
  } else if (!viewParam) {
    showAll('.wholesale-login-subtle');
    hideAll('.wholesale-apply');
  }
});
